import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';

import { AuthService } from '@app/shared/services';
import { UserRepository, UserService } from '@state/user';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class LoginRedirectGuard {
  private authService = inject(AuthService);
  private router = inject(Router);
  private userRepository = inject(UserRepository);
  private userService = inject(UserService);

  canActivate(): boolean {
    let loggedIn = this.authService.loggedIn();

    if (environment.runtimeEnv !== 'production') return true;

    if (loggedIn) {
      if (!this.userRepository.getHasFetchedUser()) this.userService.setUserFromAuth();
      void this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
